import { forwardRef, memo } from "react"
import _uniqueId from "lodash/uniqueId"
import styled from "styled-components"

export default memo(
  forwardRef(function ToggleButton({ ...rest }, ref) {
    const toggleBtnId = _uniqueId("toggle-btn-")
    return (
      <>
        <SwitchInput ref={ref} type="checkbox" id={toggleBtnId} {...rest} />
        <SwitchLabel htmlFor={toggleBtnId} />
      </>
    )
  })
)

const SwitchInput = styled.input`
  display: none;

  &:checked + label {
    background-color: #ffcf19;
  }
  &:checked + label::before {
    left: calc(100vw * (39 / 375));
    transform: translate(-100%, -50%);
  }
`

const SwitchLabel = styled.label`
  position: relative;
  background-color: rgb(116, 116, 116, 0.4);
  border-radius: calc(100vw * (20 / 375));
  width: calc(100vw * (40 / 375));
  height: calc(100vw * (22 / 375));

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: calc(100vw * (1 / 375));
    background-color: #fff;
    border-radius: 100%;
    transform: translateY(-50%);
    transition: all 0.4s ease;
    box-shadow: 0px calc(100vw * (0.5 / 375)) calc(100vw * (4 / 375)) rgba(0, 0, 0, 0.2);
    width: calc(100vw * (20 / 375));
    height: calc(100vw * (20 / 375));
  }
`
